import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callUserObjective } from "../../haz/request/request.section";
import { callRequestDepartment } from "../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { dateDiffStr } from "../../../../utils/date";
import lodash from "lodash";
import numeral from "numeral";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () => i18n.global.t("views.report.importSample"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({ title: () => i18n.global.t("views.report.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refOperation"),
            dataIndex: "refOperation.value",
            inputProp: () => ({
                list: ({ searchQuery }) => callUserObjective({ searchQuery }).then(objective => objective.filter(d => ["1"].includes(d.key))),
                optLabel: "value"
            }),
            search: { visible: () => false, name: "refOperation.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.informProduct.refHazObject"),
            dataIndex: "products.refHazObject.nameTh",
            dataIndexValue: ({ record }) => {
                return record.products?.map(d => d.refHazObject?.nameTh).join("\r\n")
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
        }),
        createColumnInput({
            title: () => i18n.global.t("model.informProduct.tradeName"),
            dataIndex: "products.refHazObject.nameTh",
            dataIndexValue: ({ record }) => {
                return record.products?.map(d => (d.tradeName || " ")).join("\r\n")
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: () => callRequestDepartment({ refRequestDocKey: "02" }),
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { visible: () => false, name: "refDepartment.id" },
            width: 200
        }),
        createColumnInput({
            title: () => i18n.global.t("model.inform.invoiceCode"),
            dataIndex: "products.invoiceCode",
            dataIndexValue: ({ record }) => record.products.map(d => d.invoiceCode).join("\r\n"),
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "center"
        }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.docTimeLive"),
            // dataIndexValue: () => "3 เดือน",
            dataIndexValue: ({ record }) => dateDiffStr({ record }), sorter: false,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),

        createColumnDate({
            title: () => i18n.global.t("views.report.releaseDate"),
            dataIndex: "refInspection.refRelease.releaseDate",
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.weight"),
            dataIndex: "qty",
            dataIndexValue: ({ record }) => {
                const productQties = record.products?.flatMap(d => d.productQties || []) || [];
                return numeral(lodash.sum(productQties.map(d => d.qty || 0))).format("0,0.00")
                // const qtyGroup = lodash.groupBy(productQties, "refQtyUnit.value")
                // return Object.keys(qtyGroup).map(key => `${numeral(lodash.sum(qtyGroup[key].map(d => d.qty || 0))).format("0,0.00")} ${key}`).join(", ");
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "right",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.packagingCharacteristic"),
            dataIndex: "refPackagingCharacteristic",
            dataIndexValue: ({ record }) => {
                const productQties = record.products?.flatMap(d => d.productQties || []) || [];
                const qtyGroup = lodash.groupBy(productQties, "refPackagingCharacteristic.value")
                return Object.keys(qtyGroup).map(key => `${key}`).join(", ");
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("views.report.amount"),
            dataIndex: "amount",
            dataIndexValue: ({ record }) => {
                const productQties = record.products?.flatMap(d => d.productQties) || [];
                return numeral(lodash.sum(productQties.map(d => d.amount || 0))).format("0,0.00");
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "right",
            width: 120,
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
